// extracted by mini-css-extract-plugin
export default {"cartContainer":"IP","summarycontent":"JP","offset":"KP","leaf":"LP","summaryclosed":"MP","summaryheader":"NP","summaryitems":"OP","summaryprice":"PP","buttonopen":"QP","buttondown":"RP","summaryfixed":"SP","usdnotification":"TP","renew":"UP","promowrapper":"VP","ordersummarywrap":"WP","simplewrap":"XP"};
    if(module.hot) {
      // 1713211523324
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  